import { parseCpf } from '@brazilian-utils/brazilian-utils';
import { StringManager } from '@payments-checkout/shared/helpers/index';

const sendBillingAddressPayloadBuilder = (
  paymentData: google.payments.api.PaymentData
) => {
  return {
    address: {
      city: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.locality,
        'city'
      ),
      state: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.administrativeArea,
        'state'
      ),
      country: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.countryCode,
        'country'
      ),
      neighborhood:
        paymentData.paymentMethodData.info?.billingAddress
          ?.administrativeArea ?? '',

      zip_code: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.postalCode,
        'zip_code'
      ),
      number: 'S/N',
      street: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.address1,
        'street'
      ),
      complement: paymentData.paymentMethodData.info?.billingAddress?.address2,
    },
  };
};

const sendCustomerDataPayloadBuilder = (
  paymentData: google.payments.api.PaymentData,
  paymentLinkId: string,
  digitalWalletDocument: any,
  digitalWalletPhone: any,
  sessionId?: string
) => {
    const countryCode =
    digitalWalletPhone.countryCode?.toString()?.replace(/[^0-9]/g, '') || '';
  const areaCode =
    digitalWalletPhone.phone
      ?.toString()
      ?.replace(/[^0-9]/g, '')
      .substr(0, 2) || '';

  const isCnpj = digitalWalletDocument.documentType === 'cnpj';

  return {
    paymentLinkId,
    sessionId: StringManager.throwIfEmpty(sessionId, 'sessionId'),
    customerData: {
      email: StringManager.throwIfEmpty(paymentData.email, 'email'),
      name: StringManager.throwIfEmpty(
        paymentData.paymentMethodData.info?.billingAddress?.name,
        'name'
      ),
      document: isCnpj
        ? digitalWalletDocument.document?.replace(/[^A-Z0-9]/gi, '').toUpperCase() || ""
        : parseCpf(digitalWalletDocument.document ?? ''),
      document_type: digitalWalletDocument.documentType,
      type: isCnpj ? 'company' : 'individual',
      phones: {
      mobile_phone: {
        country_code: countryCode,
        area_code: areaCode,
        number:
          digitalWalletPhone.phone
            ?.toString()
            ?.replace(/[^0-9]/g, '')
            .substr(2) || '',
      },
    },
    },
  };
};

export const googlePayPayloadBuilder = {
  sendBillingAddressPayloadBuilder,
  sendCustomerDataPayloadBuilder,
};
